// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"6bfa0c06","453":"7bae7655","629":"a91ccf12","705":"b3ababb6"}[chunkId] + ".chunk.js";
};